/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Careers',
    titleMeta: 'Careers — Job vacancies | CamDiab',
    descriptionMeta: 'Explore career opportunities at CamDiab. Join our team working to improve life for people living with diabetes.',
    keywords: 'CamDiab careers, jobs, vacancies, diabetes technology',
    localeMeta: 'en_gb',

    bannerTitle: 'Job vacancies',
    bannerSubtitle: 'Interested in joining our team?',
    heroNote: 'All job postings are published in English.',

    introBody:
        'If you are looking for a new challenge and would like to help shape meaningful change, we’d love to hear from you. We invest in the people who are the beating heart of CamDiab. Our employee benefits have been designed to bring the best out of everyone:',

    benefitsTitle: '',
    benefits: [
        'Generous employer pension contribution (including salary sacrifice pension scheme)',
        'Private medical and travel insurance',
        'Life assurance',
        'Annual discretionary bonus',
        '29 days annual leave, plus 8 days Bank Holiday',
        'Competitive salary',
        'Hybrid working structure with at least one day a week in our Cambridge office',
        'Opportunity to work on groundbreaking technology and transform diabetes management',
    ],

    outroHtml:
        'If you’re passionate about making real-world impact, we’d love to hear from you:<br/><br/><a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    /* Job listings. Use vacancies: [] to show only the “No current vacancies” accordion. */
    vacancies: [],

    emptyVacancyTitle: 'No current vacancies',
    emptyVacancyBody:
        'We may not be hiring at the moment, but CamDiab is growing, and we are always interested in hearing from people who are passionate about making life better for those living with diabetes. Please check back here for future opportunities.',

    applyLabel: 'Apply now',
};
